import { ISearchRequest } from '@gr/shared/models';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosPost } from '../authAxios';

interface IGetClientsRequest extends ISearchRequest { }

export default function useClients() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ['clients'],
    queryFn: async () => {
      const axios = await axiosPost('clients-search');
      return axios.data?.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
  const mutation = useMutation({
    mutationFn: async (request: IGetClientsRequest) => {
      const axios = await axiosPost('clients-search', request);
      return axios.data?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    }
  });
  return { query, mutation };
}